// Module
var code = "<span class=\"{{item.itemClass}}\">{{item.name}}</span> ";
// Exports
export default code;